(function (scope) {

scope.FadeInOnScroll = function () {
	this._scrollEls;
	this.init = function () {
		this._scrollEls = {};

		//get all affected DOM els
		var els = [];
		// $(".widget.widget-full-width > .widget-title, .widget:not(.widget-full-width)").each (function () {
		$(".copy").each (function () {
			els = els.concat ($(this).siblings ().toArray ());
			els.push (this);
		});
		// $(".shared-vision-item h3, .shared-vision-item .copy, .shared-vision-item .blurb").each (function () {
		// 	els.push (this);
		// });
		// console.log (els);
		var el;
		var offset;
		var top;
		for (var i in els) {
			el = els [i];
			offset = $(el).offset ();
			top = Math.floor (offset.top / 10) * 10;
			if (!this._scrollEls [top]) this._scrollEls [top] = [];
			this._scrollEls [top].push (el);
			if (!$(el).hasClass ("fade-in-on-scroll-disabled")) {
				$(el).addClass ("fade-in-on-scroll-invisible");
			}
		}

		//set their start states
		// TweenMax.set (".widget.widget-full-width .widget-title, .widget:not(.widget-full-width)", {opacity: 0, y: 25});
		// TweenMax.set ($(".widget.widget-full-width .widget-title").siblings (), {opacity: 0, y: 25});
		this.setStartStates ();

		var thisClass = this;
		$(window).on ("scroll.FadeInOnScroll", function () {
			// console.log ("FadeInOnScroll.scroll");
			thisClass.onScroll.apply (thisClass);
		});
	};

	this.setStartStates = function () {
		var scrollTop = $(window).scrollTop ();
		var toRemoves = [];
		for (var top in this._scrollEls) {
			if (top > scrollTop + window.innerHeight) {
				//fade these out, 'coz they are yet to be scrolled to
				// console.log ("FadeInOnScroll.setStartStates top", top, this._scrollEls [top]);
				TweenMax.set (this._scrollEls [top], {alpha: 0, y: 25});
			} else {
				//already on screen, so remove from scroll list
				toRemoves.push (top);
			}
		}
		for (var i in toRemoves) {
			// console.log ("FadeInOnScroll.setStartStates remove", this._scrollEls [toRemoves [i]]);
			// console.log ("FadeInOnScroll.onScroll trigger", this._scrollEls [toRemoves [i]], "onFadeInOnScrollStart");
			$(this._scrollEls [toRemoves [i]]).trigger ("onFadeInOnScrollStart");
			$(this._scrollEls [toRemoves [i]]).trigger ("onFadeInOnScrollComplete");
			$(this._scrollEls [toRemoves [i]]).each (function () {$(this).removeClass ("fade-in-on-scroll-invisible")});
			delete (this._scrollEls [toRemoves [i]]);
		}
	};

	this.onScroll = function () {
		var scrollTop = $(window).scrollTop ();
		// console.log ("FadeInOnScroll.onScroll scrollTop", scrollTop);
		var toFades = [];
		var toRemoves = [];
		var hasToFade;
		var actualTop;
		var testEl;
		var testOffset;
		for (var top in this._scrollEls) {
			// console.log ("FadeInOnScroll.onScroll top", top);
			hasToFade = true;
			testEl = this._scrollEls [top][0];
			testOffset = $(testEl).offset ();
			// actualTop = Math.floor (testOffset.top / 10) * 10;
			actualTop = Math.floor (testOffset.top / 5) * 5;
			// console.log ("FadeInOnScroll.onScroll testEl", testEl, "testOffset", testOffset, "actualTop", actualTop);
			// if (actualTop < scrollTop + window.innerHeight - window.innerHeight * 0.25 || scrollTop >= $(document).height () - window.innerHeight * 1.1) {
			if (actualTop < scrollTop + window.innerHeight || scrollTop >= $(document).height () - window.innerHeight) {
				// console.log ("FadeInOnScroll.onScroll", this._scrollEls [top]);
				toRemoves.push (top);
				toFades = toFades.concat (this._scrollEls [top]);
			}
		}
		var tl = new TimelineMax ();
		tl.addLabel ("start");
		for (var i in toFades) {
			tl.to (toFades [i], window.tweenDurationVeryQuick, {
				alpha: 1,
				y: 0,
				ease: window.tweenEaseVeryQuick,
				onStart: function () {
					// console.log ("FadeInOnScroll.onScroll", this.target, "trigger onFadeInOnScrollStart");
					$(this.target).each (function () {$(this).trigger ("onFadeInOnScrollStart");});
				},
				onComplete: function () {
					// console.log ("FadeInOnScroll.onScroll", this.target, "trigger onFadeInOnScrollComplete");
					$(this.target).each (function () {$(this).trigger ("onFadeInOnScrollComplete");});
				}
			}, "-=0.25");
		};
		for (var i in toRemoves) {
			$(this._scrollEls [toRemoves [i]]).each (function () {$(this).removeClass ("fade-in-on-scroll-invisible")});
			delete (this._scrollEls [toRemoves [i]]);
		}
		if (!hasToFade) {
			//turn off scroll
			// console.log ("FadeInOnScroll.onScroll turn off");
			$(window).off ("scroll.FadeInOnScroll");
		}
	};

	var thisClass = this;
	if (window.requestAnimationFrame) {
		window.requestAnimationFrame (function () {
			window.requestAnimationFrame (function () {
				window.requestAnimationFrame (function () {
					thisClass.init.apply (thisClass);
				});
			});
		});
	}
}

}) (window);
